import { Flex } from "@chakra-ui/layout";
import { formatMoney } from "infra/helpers/number";

interface ContentRightItemProps {
  titulo: string;
  valor?: number;
}

export default function ContentRightItem({
  titulo,
  valor,
}: ContentRightItemProps) {
  return (
    <Flex>
      <Flex color="#768398" fontSize="12px" flex={4}>
        {titulo}
      </Flex>
      <Flex fontSize="12px" ml={20}>
        {formatMoney(valor)}
      </Flex>
    </Flex>
  );
}
